import React from 'react';

const FloralDivider = ({ variant = 'lavender' }) => {
  const colors = {
    lavender: {
      line: 'from-transparent via-lavender-400/40 to-transparent',
      glow1: 'bg-lavender-300/25',
      glow2: 'bg-lilac-300/20',
      petal: 'bg-lavender-400/30'
    },
    lilac: {
      line: 'from-transparent via-lilac-400/40 to-transparent',
      glow1: 'bg-lilac-300/25',
      glow2: 'bg-lavender-300/20',
      petal: 'bg-lilac-400/30'
    },
    violet: {
      line: 'from-transparent via-violet-400/40 to-transparent',
      glow1: 'bg-violet-300/25',
      glow2: 'bg-lilac-300/20',
      petal: 'bg-violet-400/30'
    }
  };

  const c = colors[variant] || colors.lavender;

  return (
    <div className="relative h-20 overflow-visible" aria-hidden="true">
      {/* Main gradient line */}
      <div className={`absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r ${c.line}`} />
      
      {/* Floating floral glows */}
      <div className={`absolute top-1/2 left-1/4 -translate-y-1/2 w-16 h-16 ${c.glow1} rounded-full blur-xl opacity-60`} />
      <div className={`absolute top-1/2 right-1/4 -translate-y-1/2 w-12 h-12 ${c.glow2} rounded-full blur-xl opacity-50`} />
      
      {/* Center floral element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        {/* Petals arranged in flower pattern */}
        <div className={`absolute -top-3 left-1/2 -translate-x-1/2 w-2 h-5 ${c.petal} rounded-full blur-[1px]`} />
        <div className={`absolute -bottom-3 left-1/2 -translate-x-1/2 w-2 h-5 ${c.petal} rounded-full blur-[1px]`} />
        <div className={`absolute top-1/2 -left-3 -translate-y-1/2 w-5 h-2 ${c.petal} rounded-full blur-[1px]`} />
        <div className={`absolute top-1/2 -right-3 -translate-y-1/2 w-5 h-2 ${c.petal} rounded-full blur-[1px]`} />
        
        {/* Diagonal petals */}
        <div className={`absolute -top-2 -left-2 w-3 h-3 ${c.petal} rounded-full blur-[1px]`} />
        <div className={`absolute -top-2 -right-2 w-3 h-3 ${c.petal} rounded-full blur-[1px]`} />
        <div className={`absolute -bottom-2 -left-2 w-3 h-3 ${c.petal} rounded-full blur-[1px]`} />
        <div className={`absolute -bottom-2 -right-2 w-3 h-3 ${c.petal} rounded-full blur-[1px]`} />
        
        {/* Center */}
        <div className="w-4 h-4 bg-lavender-300/50 rounded-full blur-[2px]" />
      </div>
      
      {/* Side accent dots */}
      <div className={`absolute top-1/2 left-[15%] -translate-y-1/2 w-1.5 h-1.5 ${c.petal} rounded-full`} />
      <div className={`absolute top-1/2 right-[15%] -translate-y-1/2 w-1.5 h-1.5 ${c.petal} rounded-full`} />
    </div>
  );
};

export default FloralDivider;
